/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path pid="0" _fill="#848484" d="M7.231 9.544V1.42H1.486v8.124h5.745zM.486.42h7.745v10.124H.486V.42zm15.617 5.27V1.42h-5.745v4.27h5.745zM9.358.42h7.745v6.27H9.358V.42zm6.744 17V9.296h-5.745v8.124h5.745zM9.357 8.296h7.745V18.42H9.357V8.296zm-2.126 9.123v-4.268H1.486v4.268h5.745zM.486 12.151h7.745v6.268H.486v-6.268z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/dashboard.js